import { FormProps, AppFormTabProps } from 'components/AppFormLayout/AppFormData'

export const FormDemoData = [
	{
		tabId: 0,
		title: '新分区',
		isHidden: false,
		appFormBlockList: [
			{
				colNumber: 2,
				title: '222',
				labelWidth: 120,
				appFormItemList: [
					{
						type: 'Input',
						dataType: 'string',
						field: 'name',
						label: '用户名',
						req: true,
					},
					{
						type: 'Input',
						dataType: 'string',
						field: 'account',
						label: '账号',
						req: true,
					},
					{
						type: 'Select',
						isHidden: false,
						dataType: 'number',
						field: 'disabled',
						label: '是否禁用',
						req: true,
						appFormItemOptionList: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
					},
					{
						type: 'Input',
						isHidden: true,
						dataType: 'number',
						field: 'organ_id',
						label: '公司id',
						req: true,
					},
				],
			},
		],
	},
	// {
	// 	tabId: 1,
	// 	title: '新分区1',
	// 	isHidden: false,
	// 	appFormBlockList: [
	// 		{
	// 			colNumber: 1,
	// 			title: '222',
	// 			appFormItemList: [
	// 				{
	// 					type: 'Input',
	// 					defaultValue: '111',
	// 					field: 'a1',
	// 					label: '合同名称',
	// 					req: true,
	// 				},
	// 			],
	// 		},
	// 	],
	// },
	// {
	// 	tabId: 2,
	// 	title: '新分区2',
	// 	isHidden: false,
	// 	appFormBlockList: [
	// 		{
	// 			colNumber: 1,
	// 			title: '222',
	// 			appFormItemList: [
	// 				{
	// 					type: 'Input',
	// 					defaultValue: '111',
	// 					field: 'a1',
	// 					label: '合同名称',
	// 					req: true,
	// 				},
	// 			],
	// 		},
	// 	],
	// },
] as AppFormTabProps[]



// WEBPACK FOOTER //
// ./src/modules/modeling/page/FormDemoData.tsx